import gameConfig, { randomBetween } from '../config/gameConfig'

function pickLine(lines) {
  return lines[Math.floor(Math.random() * lines.length)]
}

function rollAccept(probability) {
  return Math.random() < probability
}

export function delayForNegotiation(type) {
  const cfg = gameConfig.negotiation[type]
  return randomBetween(cfg.thinkMsMin, cfg.thinkMsMax)
}

/** 模拟对手对和棋请求的回应 */
export function resolveDrawRequest() {
  const cfg = gameConfig.negotiation.draw
  const accepted = rollAccept(cfg.acceptProbability)
  return {
    accepted,
    message: accepted ? pickLine(cfg.acceptLines) : pickLine(cfg.rejectLines),
  }
}

/** 模拟对手对悔棋请求的回应 */
export function resolveUndoRequest() {
  const cfg = gameConfig.negotiation.undo
  const accepted = rollAccept(cfg.acceptProbability)
  return {
    accepted,
    message: accepted ? pickLine(cfg.acceptLines) : pickLine(cfg.rejectLines),
  }
}

export function maxUndosPerGame() {
  return gameConfig.negotiation.undo.maxUndosPerGame
}

/** AI 是否在本回合主动求和 */
export function shouldAiRequestDraw(moveIndex) {
  const cfg = gameConfig.negotiation.aiProactiveDraw
  if (!cfg.enabled || moveIndex < cfg.minMoveIndex) return false
  return Math.random() < cfg.probabilityPerTurn
}

export function maybeIdleOpponentChat() {
  const d = gameConfig.disguise
  if (!d.chatEnabled || Math.random() >= d.idleChatProbability) return null
  return d.idleChatLines[Math.floor(Math.random() * d.idleChatLines.length)]
}